<template>
  <v-dialog
    v-model="dialog"
    max-width="20rem"
    persistent
    scrollable
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-btn :block="$vuetify.breakpoint.xsOnly" text v-on="on" color="success">
        <v-icon left small>fa-plus</v-icon>
        Nouveau évènement
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-row align="center" justify="end" no-gutters>
          <v-btn icon @click="dialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <EventInput
          ref="form"
          v-bind.sync="event"
          :valid.sync="valid"
        ></EventInput>
      </v-card-text>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-btn
              v-if="event.id === undefined"
              block
              color="success"
              :loading="loading"
              @click="createEvent"
              :disabled="!valid"
            >
              <v-icon left small>fa-calendar-plus</v-icon>
              Ajouter
            </v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-btn
              v-if="event.id !== undefined"
              block
              color="success"
              :loading="loading"
              @click="updateEvent"
              :disabled="!valid"
            >
              <v-icon left small>fa-calendar-check</v-icon>
              Enregistrer
            </v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-btn
              class="mt-2"
              v-if="event.id !== undefined"
              block
              color="error"
              :loading="loading"
              @click="deleteEvent"
              :disabled="!valid"
            >
              <v-icon left small>fa-calendar-times</v-icon>
              Supprimer
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import EventInput from "./EventInput";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "EventEditorDialog",
  components: {
    EventInput
  },
  computed: {
    ...mapGetters(["getEvents", "getOrganisationId"])
  },
  data() {
    return {
      loading: false,
      dialog: false,
      valid: false,
      event: {
        name: "",
        start: moment().format("YYYY-MM-DD"),
        end: null
      }
    };
  },
  methods: {
    async createEvent() {
      try {
        this.loading = true;
        const d = {
          ...this.event,
          organisation: this.getOrganisationId,
          year: moment(this.event.start).format("YYYY")
        };
        await this.$store.dispatch("postEvent", d);
      } finally {
        this.loading = false;
        this.dialog = false;
      }
    },
    async updateEvent() {
      try {
        this.loading = true;
        const d = {
          ...this.event,
          organisation: this.getOrganisationId,
          year: moment(this.event.start).format("YYYY")
        };
        await this.$store.dispatch("updateEvent", d);
        this.resetEvent();
      } finally {
        this.loading = false;
        this.dialog = false;
      }
    },
    async deleteEvent() {
      try {
        this.loading = true;
        const d = {
          ...this.event,
          organisation: this.getOrganisationId,
          year: moment(this.event.start).format("YYYY")
        };
        await this.$store.dispatch("deleteEvent", d);
        this.resetEvent();
      } finally {
        this.loading = false;
        this.dialog = false;
      }
    },
    resetEvent() {
      this.event = {
        name: "",
        start: moment().format("YYYY-MM-DD"),
        end: null
      };
    },
    open(event) {
      this.event = event;
      this.dialog = true;
    }
  },
  watch: {
    dialog(v) {
      if (v === false) this.resetEvent();
    }
  }
};
</script>

<style></style>
